import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[formSubmittable]',
})
export class FormSubmittableDirective {
  @Input() formSubmittable: () => void;

  constructor() {}

  @HostListener('keyup', ['$event'])
  keyup($event) {
    if ($event && $event.keyCode == 13 && this.formSubmittable) {
      this.formSubmittable();
    }
  }

  @HostListener('submit', ['$event'])
  submit() {
    if (this.formSubmittable) this.formSubmittable();
  }
}
